module.exports = __webpack_public_path__ + "static/media/email-green.95b1ee4b.svg";